module.exports = __webpack_public_path__ + "img/search-icon.cb902a32.svg";